import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .service(
    'preferencesBusyTimes',
    function (this: any, preferencesSummaryDelegate: any, ngTimeOccurrenceDataSource: any) {
      this.getSummary = () => {
        const busyTimes = _4.filter(ngTimeOccurrenceDataSource.store, (time: any) => !time.isLocked);
        preferencesSummaryDelegate.setBusyTime({ busyTimes });
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/services/preferences_busy_times.ts